export const earningsCsvFilter = (section, row, content) => {
    let csv = content;
    if (section === "Recharge" && row === "Margin") {
      csv =
        content &&
        content.map((obj) => {
          obj["Retailer"] = obj["retailer"] ?? "";
          obj["Margin Amount"] = obj["marginAmt"] ?? "";
          obj["Transaction Date"] = obj["tnxdate"] ?? "";
          obj["Processed Date"] = obj["processedDate"] ?? "";
          delete obj["retailer"];
          delete obj["marginAmt"];
          delete obj["tnxdate"];
          delete obj["processedDate"];
          return obj;
        });
    } else if (section === "Recharge" && row === "Recharge Incentive") {
      csv =
        content &&
        content.map((obj) => {
          obj["Scheme Name"] = obj["scheme"] ?? "";
          obj["Quantity"] = obj["qty"] ?? "";
          obj["Value"] = obj["val"] ?? "";
          obj["Transaction Date"] = obj["hiredate"] ?? "";
          obj["Processed Date"] = obj["processedDate"] ?? "";
          delete obj["scheme"];
          delete obj["qty"];
          delete obj["val"];
          delete obj["hiredate"];
          delete obj["processedDate"];
          return obj;
        });
    } else if (section === "Activation") {
      csv =
        content &&
        content.map((obj) => {
          obj["Scheme Name"] = obj["scheme"] ?? "";
          obj["Quantity"] = obj["quantity"] ?? "";
          obj["Value"] = obj["payoutValue"] ?? "";
          obj["Transaction Date"] = obj["hireDate"] ?? "";
          obj["Processed Date"] = obj["processedDate"] ?? "";
          delete obj["scheme"];
          delete obj["quantity"];
          delete obj["payoutValue"];
          delete obj["hireDate"];
          delete obj["processedDate"];
          return obj;
        });
    } else if (section === "jiophone" || section === "device") {
      if (row === "CUT_N_PAY") {
        csv =
          content &&
          content.map((obj) => {
            obj["Retailer"] = obj["retailer"] ?? "";
            obj["Amount"] = obj["val"] ?? "";
            obj["Quantity"] = obj["qty"] ?? "";
            obj["Transaction Date"] = obj["hiredate"] ?? "";
            obj["Processed Date"] = obj["processedDate"] ?? "";
            delete obj["hiredate"];
            delete obj["processedDate"];
            delete obj["qty"];
            delete obj["val"];
            delete obj["retailer"];
            delete obj["scheme"];
            return obj;
          });
      } else {
        csv =
          content &&
          content.map((obj) => {
            obj["Scheme Name"] = obj["scheme"];
            obj["Quantity"] = obj["qty"];
            obj["Value"] = obj["val"];
            obj["Transaction Date"] = obj["hiredate"];
            obj["Processed Date"] = obj["processedDate"];
            delete obj["hiredate"];
            delete obj["processedDate"];
            delete obj["qty"];
            delete obj["val"];
            delete obj["retailer"];
            delete obj["scheme"];
            return obj;
          });
      }
    }
    return csv;
  };